import { useSelector } from 'react-redux';

import { ConfigStep } from './fulfillment-product-import/config-step';
import { ImportType } from '../../../../../../components/csv-import/data/types/import-type';
import { ImportState } from '../../../../../../components/csv-import/ui/components/import-state';
import { useCsvImport } from '../../../../../../components/csv-import/ui/hooks/use-csv-import';
import { ProductsGridViewIds } from '../../../../../../constants/grid-view-ids';
import Global from '../../../../../../store/global-selectors';

export const Body = () => {
  const { open } = useCsvImport(ImportType.fulfillmentProduct);
  const latestImport = useSelector((state) => Global.selectCsvImportType(state, ImportType.fulfillmentProduct));

  return latestImport.status ? (
    <ImportState importType={ImportType.fulfillmentProduct} linkToSeeImportResult={ProductsGridViewIds.PRODUCTS} open={open} />
  ) : (
    <ConfigStep />
  );
};
